export enum OperationsTypes {
  GET_DATA_OPERATIONS = 'GET_DATA_OPERATIONS',
  GET_OPERATION = 'GET_OPERATION',
  GET_TYPES_OPERATION = 'GET_TYPES_OPERATION',
  SET_LOADING_OPERATION = 'SET_LOADING_OPERATION',
  SET_LOADING_DETAIL_OPERATION = 'SET_LOADING_DETAIL_OPERATION',
  APPEND_OPERATION = 'APPEND_OPERATION',
  LOGOUT = 'LOGOUT'
}
